import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useEgiftSales = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.egiftSales, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getEgiftSales(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        clinicEgiftSales: res.data.data.clinic_egift_sales,
        providerEgiftSales: res.data.data.provider_egift_sales,
      };
      return composeResponse;
    },
    options,
  );
};
